import Vue from 'vue'
import ModalComponent from './modal'
function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
};
let instance;
let ModalConstructor = Vue.extend(ModalComponent);

let initInstance = ()=>{
  instance = new ModalConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
}

let Modal = (options={}) => {
  initInstance();
  merge(instance.$props, options);
  return new Promise((resolve, reject)=>{
    instance.isShow = true;
    let success = instance.success;
    let cancel = instance.cancel;
    instance.success = () => {
      success();
      resolve('ok');
    }
    instance.cancel = () => {
      cancel();
      resolve('cancel');
    }
  });

}
export default Modal
/*export default {
  install(Vue){
    Vue.component(Modal.name, Modal)
    //添加全局API
    Vue.prototype.$modal = Modal
  }
}*/



// WEBPACK FOOTER //
// ./src/plugins/modal/index.js